import {BehaviorSubject, Subject} from "rxjs";

export class ValidationService {
  private validateSource = new Subject<void>();
  validate$ = this.validateSource.asObservable();
  private validationStatusSource = new BehaviorSubject<boolean>(true);
  validationStatus$ = this.validationStatusSource.asObservable();

  triggerValidation() {
    this.validateSource.next();
  }

  updateValidationStatus(isValid: boolean) {
    if (!isValid) {
      this.validationStatusSource.next(false);
    }
  }

  resetValidationStatus() {
    this.validationStatusSource.next(true);
  }
}